<template>
  <div class="subscribe-wrapper">

    <div class="menu">

      <div class="add-subscribe-button" @click="addSubscribeFunc()">
        <i>+</i><span>添加订阅</span>
      </div>

      <template v-if="!isLoading && subscribeList.length">

        <div class="menu-title">已订阅</div>
        <div class="subscribe-list" v-loading="isLoading">
          <div class="subscribe-item" :class="{'active': index === nowSearchDataIndex}" v-for="(item, index) in subscribeList" :key="index" @click="clickSubscribeItemFunc(item, index)">
            <p class="subscribe-item-title">{{ item.keyword }}</p>
            <p class="subscribe-item-content">
              <span>{{ item.expected_location }}</span>
              <i class="separator"></i>
              <span>{{ item.degree | textFilterFunc('学历') }}</span>
              <i class="separator"></i>
              <span>{{ item.school_tags | textFilterFunc('院校') }}</span>
              <i class="separator"></i>
              <span>{{ item.experiences | textFilterFunc('经验') }}</span>
            </p>
          </div>
        </div>

      </template>

      <template v-if="!isLoading && !subscribeList.length">

        <div class="not-subscribe-box">
          <img src="https://files.wondercv.com/company/privacy-company-zero.png" alt="">
          <p>当前暂无订阅～<br/>点击上方「添加订阅」订阅人才</p>
        </div>

      </template>

    </div>

    <div class="content">

      <div class="active-subscribe" v-if="subscribeList.length">
        <div class="active-subscribe-left">
          <img class="active-subscribe-icon" src="https://files.wondercv.com/hr-pc/recommend/subscribe-header.png" alt="">
          <span class="active-subscribe-title">{{ nowSearchData.keyword }}</span>
          <span class="active-subscribe-text">{{ nowSearchData.expected_location }}</span>
          <span class="active-subscribe-text">{{ nowSearchData.degree | textFilterFunc('学历') }}</span>
          <span class="active-subscribe-text">{{ nowSearchData.school_tags | textFilterFunc('院校') }}</span>
          <span class="active-subscribe-text">{{ nowSearchData.experiences | textFilterFunc('经验')}}</span>
        </div>
        <div class="active-subscribe-right" @click="editSubscribeFunc">
          <div class="edit-subscribe-button">编辑</div>
        </div>
      </div>

      <div class="card-list">
        <template v-if="subscribeList.length">
          <cvCardList :searchData="searchData" :recommendTagVisible="true" />
        </template>
        <template v-else>
          <div class="not-search-box">
            <img src="https://files.wondercv.com/b-pc/no-search-data.png" alt="">
            <p>你可以在左侧添加关键词和筛选条件，订阅人才库。<br/>当订阅的人才库有更新时，及时收到提醒</p>
          </div>
        </template>
      </div>

    </div>

    <!-- 订阅弹窗 -->
    <subscribeBlock v-if="subscribeDialogVisible"
                    :titleText="subscribeBlockBackfillVisible ? '编辑订阅' : '添加订阅'"
                    :confirmButtonText="subscribeBlockBackfillVisible ? '保存' : '新增订阅'"
                    :backfillVisible="subscribeBlockBackfillVisible"
                    :backfillData="subscribeBlockBackfillData"
                    @confirmFunc="subscribeBlockConfirmFunc"
                    @cancelFunc="subscribeBlockCancelFunc"
                    @deleteFunc="subscribeBlockDeleteFunc" />

  </div>
</template>

<script>
import actions from '@/actions/index'
import cvCardList from '../components/cvCardList/Index'
import subscribeBlock from '../components/subscribeBlock/Index'
import { mapState, mapMutations, mapActions } from 'vuex'
import { get_tUser } from '../../../../../utils/utils'

export default {
  data () {
    return {
      nowSearchData: {}, // 当前搜索条件
      nowSearchDataIndex: -1, // 当前搜索条件索引
      subscribeList: [], // 订阅列表
      searchData: { // 添加订阅 订阅弹窗返回的订阅数据
        keyword: '', // 关键词 用户输入
        city: '全国', // 城市 单选
        degree: [], // 学历 多选
        school: [], // 院校 多选
        experience: [] // 工作经验 多选
      },
      subscribeBlockBackfillData: { // 订阅弹窗的回填数据
        keyword: '',
        city: '全国',
        degree: [],
        school: [],
        experience: []
      },
      subscribeBlockBackfillVisible: false, // 订阅弹窗是否启用回填 
      subscribeDialogVisible: false, // 订阅弹窗 visible
      isLoading: true
    }
  },
  components: {
    cvCardList,
    subscribeBlock,
  },
  created () {
    // 设置导航栏标题（销毁时需要初始化）
    this.updateHeaderTitle('订阅人才')
    this.updateHeaderTitleVisible(true)

    this.getSubscribeList((data) => {
      this.nowSearchData = data[0]
      this.nowSearchDataIndex = 0
    })
  },
  mounted () {},
  destroyed () {
    // 销毁时需要初始化
    this.updateHeaderTitle('')
    this.updateHeaderTitleVisible(false)
  },
  filters: {
    // 逗号替换小圆点
    textFilterFunc (value, type) {
      if (!value) {
        return `${type}不限`
      }
      return value.replace(/(,)/g, ' · ')
    }
  },
  methods: {
    ...mapMutations('headerOption', ['updateHeaderTitle', 'updateHeaderTitleVisible']),

    // 格式化搜索数据
    formatSearchData () {
      let searchData = {}
      searchData.keyword = this.nowSearchData.keyword
      searchData.city = this.nowSearchData.expected_location
      searchData.degree = this.nowSearchData.degree ? this.nowSearchData.degree.split(',') : []
      searchData.school = this.nowSearchData.school_tags ? this.nowSearchData.school_tags.split(',') : []
      searchData.experience = this.nowSearchData.experiences ? this.nowSearchData.experiences.split(',') : []

      this.searchData =searchData
    },
    // 编辑订阅条件
    editSubscribeFunc () {
      let data = {}
      // 格式化回填数据
      data.keyword = this.nowSearchData.keyword
      data.city = this.nowSearchData.expected_location
      data.degree = this.nowSearchData.degree ? this.nowSearchData.degree.split(',') : []
      data.school = this.nowSearchData.school_tags ? this.nowSearchData.school_tags.split(',') : []
      data.experience = this.nowSearchData.experiences ? this.nowSearchData.experiences.split(',') : []

      this.subscribeBlockBackfillData = data

      // 将 订阅弹窗 变成 回填状态
      this.subscribeBlockBackfillVisible = true
      // 显示 订阅弹窗
      this.subscribeDialogVisible = true
    },
    // 点击订单列表 item
    clickSubscribeItemFunc (item, index) {
      this.nowSearchData = item
      this.nowSearchDataIndex = index
    },
    // 获取订阅列表
    async getSubscribeList (callback) {

      try {
        let params = {
          page: 1,
          size: 20
        }
        let res = await actions.resumes.get_subscribe_list(params)
        if (res.code === 1000) {
          if (res.data && res.data.length) {
            this.subscribeList = res.data
            callback && callback(res.data)
          } else {
            this.subscribeList = []
          }
        }
      } catch (e) {
        console.log(e)
      }

      this.isLoading = false

    },
    // 创建订阅
    async createSubscribe () {

      try {

        let params = {
          keyword: this.searchData.keyword,
          expected_location: this.searchData.city,
          degree: this.searchData.degree.join(','),
          school_tags: this.searchData.school.join(','),
          experiences: this.searchData.experience.join(',')
        }
        
        let res = await actions.resumes.create_subscribe(params)
        if (res.code === 1000) {
          this.getSubscribeList((data) => {
            this.nowSearchData = data[0]
            this.nowSearchDataIndex = 0
          })
          this.$message({
            message: '添加订阅成功',
            type: 'success'
          })
        } else if (res.code === 20218) {
          this.$message({
            message: '已为你订阅此条件',
            type: 'error'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      } catch (e) {
        console.log(e)
      }

    },
    // 编辑订阅
    async editSubscribe () {

      try {

        let params = {
          rest: this.nowSearchData.id,
          body: {
            keyword: this.searchData.keyword,
            expected_location: this.searchData.city,
            degree: this.searchData.degree.join(','),
            school_tags: this.searchData.school.join(','),
            experiences: this.searchData.experience.join(',')
          }
        }

        let res = await actions.resumes.edit_subscribe(params)
        if (res.code === 1000) {
          // 编辑成功后 重新获取订阅列表
          this.getSubscribeList((data) => {
            // 获取新的订阅列表后 更新当前显示的搜索数据
            this.nowSearchData = data[0]
            this.nowSearchDataIndex = 0
          })
          this.$message({
            message: '修改订阅成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      } catch (e) {
        console.log(e)
      }

    },
    // 删除订阅
    async deleteSubscribe () {
      
      try {

        let params = this.nowSearchData.id
        
        let res = await actions.resumes.delete_subscribe(params)
        if (res.code === 1000) {
          // 删除该订阅后 重新获取订阅列表
          this.getSubscribeList((data) => {
            // 或许新订阅列表后 重新搜索第一个订阅条件
            this.nowSearchData = data[0]
            // 如果当前nowSearchDataIndex值为0，说明删除的第一条，这个时候再把nowSearchDataIndex赋值0，数据没有变化，不会更新searchData，列表也不会重新搜索
            if (this.nowSearchDataIndex === 0) {
              this.formatSearchData()
            } else {
              this.nowSearchDataIndex = 0
            }
          })
          this.$message({
            message: '删除成功',
            type: 'success'
          })
        } else {
          this.$message({
            message: res.message,
            type: 'error'
          })
        }
      } catch (e) {
        console.log(e)
      }

    },
    // 显示 订阅弹窗
    addSubscribeFunc () {
      this.subscribeDialogVisible = true
    },
    // 订阅弹窗 确认按钮回调
    subscribeBlockConfirmFunc (data, isEditor) {
      // 存储用户选择的数据
      // 搜索数据变化了，列表会重新搜索
      this.searchData = JSON.parse(JSON.stringify(data))

      // 编辑订阅
      if (isEditor) {
        this.editSubscribe()
      //创建订阅
      } else {
        // 创建一个订阅
        this.createSubscribe()
      }
      
      // 关闭订阅弹窗
      this.subscribeDialogVisible = false
      // 每次关闭弹窗时 初始化 订阅弹窗的状态
      this.subscribeBlockBackfillVisible = false
    },
    // 订阅弹窗 取消按钮回调
    subscribeBlockCancelFunc () {
      // 关闭订阅弹窗
      this.subscribeDialogVisible = false
      // 每次关闭弹窗时 初始化 订阅弹窗的状态
      this.subscribeBlockBackfillVisible = false
    },
    // 订阅弹窗 删除按钮回调
    subscribeBlockDeleteFunc () {
      // 删除一个订阅
      this.deleteSubscribe()
      // 关闭订阅弹窗
      this.subscribeDialogVisible = false
      // 每次关闭弹窗时 初始化 订阅弹窗的状态
      this.subscribeBlockBackfillVisible = false
    }
  },
  watch: {
    nowSearchDataIndex: {
      handler: function (value) {
        // 监听到索引改变，重新设置搜索列表参数
        // 格式化搜索数据
        this.formatSearchData()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "./Index.scss";
</style>
